import { AD_STATUS } from 'modules/campaigns/config/adConsts';

export const isAdRemoved = ({ data }) =>
    data?.adStatus === AD_STATUS.TERMINATED || data?.adStatus === AD_STATUS.ARCHIVED;
